import type { Action } from 'svelte/action';

interface Attributes {
	'onenterViewport': (event: CustomEvent) => void;
}

export const onViewport: Action<HTMLElement, undefined, Attributes> = (element: Element) => {
	const observer = new IntersectionObserver((observerEntries, intersectionObserver) => {
		const observerEntry = observerEntries[0];
		if (!observerEntry.isIntersecting) {
			return;
		}

		intersectionObserver.unobserve(element);

		observerEntry.target.dispatchEvent(new CustomEvent('enterViewport'));
	}, { threshold: 0.75 });

	observer.observe(element);
};

export const onReenterViewport: Action<HTMLElement, undefined, Attributes> = (element: Element) => {
	const observer = new IntersectionObserver((entries) => {
		const entry = entries[0];
		if (!entry.isIntersecting) return;
		entry.target.dispatchEvent(new CustomEvent('enterViewport'));
	}, { threshold: 0.75 });

	observer.observe(element);

	return {
		destroy() {
			observer.disconnect();
		}
	};
};
